/* Customer videos — drag-to-scroll behaviour for the
   "Loved by Real Customers" tab thumbnail track.

   Modal open/close lives in `action-video-popup.js`
   (we reuse the existing `<m-action-video-popup>` element). */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 5; // px before a mousedown becomes a drag

  function init(root) {
    if (root.dataset.cvInit === '1') return;
    root.dataset.cvInit = '1';

    var track = root.querySelector('[data-cv-track]');
    if (!track) return;

    var openers = root.querySelectorAll('[data-open-action-video]');

    // Drag-to-scroll for mouse only (touch uses native scrolling).
    // We avoid setPointerCapture so the browser still synthesises a `click`
    // on the underlying button when the user just taps without dragging.
    var isDown = false;
    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      isDown = true;
      dragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
    });

    function onPointerMove(e) {
      if (!isDown || e.pointerId !== pointerId) return;
      var delta = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragging = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - delta;
      e.preventDefault();
    }

    function onPointerEnd(e) {
      if (!isDown || (e && e.pointerId !== pointerId)) return;
      isDown = false;
      pointerId = null;
      if (dragging) {
        track.classList.remove('is-dragging');
        // Suppress the upcoming click that would otherwise fire on the
        // pointer-up target after the drag finishes — we don't want a
        // drag to also open the modal.
        track.dataset.cvJustDragged = '1';
        setTimeout(function () { delete track.dataset.cvJustDragged; }, 60);
      }
      dragging = false;
    }

    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerEnd);
    document.addEventListener('pointercancel', onPointerEnd);

    // Block opens that happen as the tail of a drag.
    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (track.dataset.cvJustDragged === '1') {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true); // capture so we run before the action-video-popup handler
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-customer-videos]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
